// en, de, fr, pt
export default {
  en: {
    'validation':{
      nameContain: 'Your username can only contains a-z, A-Z, underscore and dot',
      No_Start: 'The {field} can\'t contain _ or . at the beginning',
      No_End: 'The {field} no _ or . at the end',
      No__Inside:'The {field} can\'t have __ or _. or .. or ._',
      glot_email:'The {field} is invalid',
      glot_login_acc:'The account is invalid'
    },
    'WelcomeBack':'Welcome back!',
    'SignInCaveat': '',
    'and': 'and',
    'SignOutWithAnother': 'Sign in with another account',
    'SignUpCaveat': 'By signing up, you agree with our Terms of Use and Privacy Policy',
    'CreateAccQuest':'I don\'t have an account?',
    'LoginAccQuest':'Have an account?',
    'SignUpNow': 'Sign up',
    'OtherPlatformsCaveat':'Use your eJOY account to access all of products on eJOY learning platform',
    'ContinueWith': 'Continue with your account',
    'SignupSuccess': 'Sign up successfully!',
    'CopyRight':'Copyright © {year} eJOY Learning Jsc.',
    'TermOfUse':'Terms of Use',
    'PrivacyPolicy':'Privacy Policy',
    'Learning': 'Learning',
    'LoginTitle': 'You can use eJOY English account to Log in on ',
    'SignInBrowserTitle': 'Sign in with your browser',
    'SignInBrowserDesc': 'For security, we’ll continue sign-in and payment in your default browser.',
    'SignInBrowserButton': 'Continue sign-in',
    'FacebookSignIn':'Sign in with Facebook',
    'GoogleSignIn': 'Sign in with Google',
    'AppleSignIn': 'Sign in with Apple',
    'FacebookSignUp': 'Sign up with Facebook',
    'GoogleSignUp': 'Sign up with Google',
    'AppleSignUp': 'Sign in with Apple',
    'Or': 'Or',
    'RegisterTitle':'Create a new account to start using',
    'SignUpWithEmail': 'Sign up with email',
    'RegisterHead': 'Set up for your account',
    'YourName':'User Name',
    'YourEmail':'Your Email',
    'DisplayName': 'Display Name',
    'YourAccount': 'Email or User Name',
    'YourPassWord':'Your Password',
    'SignMeUp':'Sign up',
    'CreateAcc': 'Create',
    'LoginAgainTitle':'Welcome back! Sign in your account below.',
    'SignInWith': 'Sign in with',
    'NotYou':'Not you?',
    'SignInDiffAcc':'Sign in with a different account',
    'ResetPasswordCaveat':'We\'ll send you a link to reset your password. Enter your email in the box below.',
    'ResetMyPassword': 'Reset my password',
    'VerificationSentTitle':'Verification sent!',
    'VerificationSentCaveat1':'A confirmation link has been sent to your email. Click the link to complete the verification process.',
    'VerificationSentCaveat2':'Make sure that you check the Spam folder as well.',
    'DonReceiveEmail':'Don\'t receive any email?',
    'Resend':'Resend',
    'TroubleCaveat':'If you have any trouble, please connect with us via: support@ejoy-english.com',
    'ForgotPassWordTitle':'We\'ll send you a link to reset your password. Enter your email in the box below',
    'CheckYourEmail':'Check your email',
    'SentEmailResetPass':'We\'ve just sent an email with instruction for resetting your password.',
    'SentEmailConfirmAcc':'A confirmation link has been sent to your email. Click the link to complete the verification process.<br> Make sure that you check the Spam/ Junk folder as well.',
    'NewPasswordTitle':'Enter your new password',
    'NewPassword':'New password',
    'ConfirmPassword': 'Confirm password',
    'Confirm': 'to confirm',
    'Submit':'Submit',
    'PasswordChanged':'Password Changed Successfully!',
    'BackToLogin':'We\'re taking you back to the Log in page',
    'Login': 'Log in',
    'Register': 'Register',
    'ForgotPassword': 'Forgot your password?',
    'VerificationSuccess':'You\'re verified!',
    'CanSendAfter': 'You can re-send after',
    'Second': 'second | seconds',
    'CheckYourEmailVerification': 'Verification sent!',
    'CheckYourEmailConfirm': 'Almost done! Check your emal',
    'SentEmailConfirmAcc1': 'A confirmation link has been sent to your email. Click the link to complete the verification process.',
    'SentEmailConfirmAccReg': 'A confirmation link has been sent to your email. Please click the link to complete the verification process.',
    'RefreshPage': 'You sign up successfully, F5 to refresh page',
    'SentEmailConfirmAcc2': 'Make sure that you check the Spam folder as well.',
    'SentEmailConfirmAccReg2': 'Make sure that you check the Spam/Junk folder as well.',
    'EmailSupportEmail': 'Need help? Please connect with us via:',
    'GlotSupportEmail': 'support@ejoy-english.com',
    'Back': 'Back',
    'BackToLoginFullPage':'Back to Login',
    'emailIsInvalid': 'Email is invalid',
    'Auth.form.error.invalid':'Identifier or password invalid.',
    'openYourBrowser': 'Open your browser',
    'openYourBrowserDesc': 'For security, please continue sign-in and payment in your external browser.',
    'gotIt': 'Got it'
  },
  vi:{
    'validation':{
      nameContain: 'Tên đăng nhập chỉ được chứa chữ không dấu, số, gạch dưới và dấu chấm',
      No_Start: '{field} không chứa _ hoặc . ở đầu',
      No_End: '{field} không chứa _ hoặc . ở cuối',
      No__Inside:'{field} không __ hoặc _. hoặc .. hoặc ._',
      glot_email:'{field} không khả dụng',
      glot_login_acc:'Tài khoản không khả dụng'
    },
    'and': 'và',
    'WelcomeBack':'Xin chào!',
    'SignInCaveat': '',
    'SignOutWithAnother': 'Đăng nhập bằng tài khoản khác',
    'SignUpCaveat': 'Bằng cách đăng ký, bạn đồng ý với Terms of Use và Privacy Policy của chúng tôi',
    'CreateAccQuest':'Không có tài khoản?',
    'LoginAccQuest':'Có tài khoản?',
    'SignUpNow': 'Đăng ký',
    'OtherPlatformsCaveat':'Bạn có thể sử dụng tài khoản vừa đăng ký cho tất cả sản phẩm  của eJOY',
    'ContinueWith': 'Tiếp tục với tài khoản của bạn',
    'SignupSuccess': 'Đăng ký tài khoản thành công!',
    'CopyRight':'Copyright © {year} eJOY Learning Jsc.',
    'TermOfUse':'Terms of Use',
    'PrivacyPolicy':'Privacy Policy',
    'Learning': 'Learning',
    'LoginTitle': 'Bạn có thể sử dụng tài khoản eJOY English để đăng nhập ',
    'SignInBrowserTitle': 'Đăng nhập ở trình duyệt khác',
    'SignInBrowserDesc': 'Để bảo mật thông tin, eJOY sẽ mở trình duyệt mặc định để bạn đăng nhập và thanh toán',
    'SignInBrowserButton': 'Tiếp tục đăng nhập',
    'FacebookSignIn':'Đăng nhập với Facebook',
    'GoogleSignIn': 'Đăng nhập với Google',
    'AppleSignIn': 'Đăng nhập với Apple',
    'FacebookSignUp': 'Đăng ký với Facebook',
    'GoogleSignUp': 'Đăng ký với Google',
    'AppleSignUp': 'Đăng ký với Apple',
    'Or': 'Or',
    'RegisterTitle':'Tạo tài khoản mới để bắt đầu sử dụng ',
    'SignUpWithEmail': 'Đăng ký với Email',
    'RegisterHead': 'Thiết lập tài khoản của bạn',
    'YourName':'Tên đăng nhập',
    'DisplayName': 'Tên người dùng',
    'YourEmail':'Email',
    'YourAccount': 'Email hoặc tên đăng nhập',
    'YourPassWord':'Mật khẩu',
    'SignMeUp':'Đăng ký',
    'CreateAcc': 'Tạo tài khoản',
    'LoginAgainTitle':'Xin chào! Đăng nhập vào tài khoản của bạn',
    'SignInWith': 'Đăng nhập với',
    'NotYou':'Không phải bạn?',
    'SignInDiffAcc':'Đăng nhập với tài khoản khác',
    'ResetPasswordCaveat':' Điền email của bạn bên dưới để nhận đường link để thay đổi mật khẩu',
    'ResetMyPassword': 'Cài đặt lại mật khẩu',
    'VerificationSentTitle':'Đã gửi!',
    'VerificationSentCaveat1':'Kiểm tra email và bấm link chúng tôi vừa gửi để hoàn tất xác nhận.',
    'VerificationSentCaveat2':'Hãy chắc chắn rằng bạn kiểm tra hộp thư rác.',
    'DonReceiveEmail':'Không nhận được email?',
    'Resend':'Gửi lại',
    'TroubleCaveat':'Nếu có thắc mắc, hãy nhắn cho chúng tôi qua support@ejoy-english.com',
    'ForgotPassWordTitle':'Chúng tôi sẽ gửi bạn một đường link để thay đổi mật khẩu. Điền email của bạn bên dưới',
    'CheckYourEmail':'Kiểm tra hòm thư',
    'SentEmailResetPass':'Chúng tôi vừa gửi bạn hướng dẫn thay đổi mật khẩu',
    'SentEmailConfirmAcc': 'Một đường link xác nhận vừa được gửi tới email của bạn. Bấm link để hoàn tất xác nhận. Hãy đảm bảo bạn kiểm tra cả hộp thư rác',
    'NewPasswordTitle':'Nhập mật khẩu mới',
    'NewPassword':'Mật khẩu mới',
    'ConfirmPassword': 'Xác nhận mật khẩu mới',
    'Confirm': 'để xác nhận',
    'Submit':'Thay đổi',
    'PasswordChanged':'Thay đổi mật khẩu thành công!',
    'BackToLogin':'Chúng tôi đang đưa bạn quay lại trang Đăng nhập...',
    'Login': 'Đăng nhập',
    'Register': 'Đăng ký',
    'ForgotPassword': 'Quên mật khẩu',
    'VerificationSuccess':'Xác nhận thành công!',
    'CanSendAfter': 'Bạn có thể gửi lại sau',
    'Second': 'giây',
    'CheckYourEmailVerification': 'Đã gửi xác nhận! Hãy kiểm tra email của bạn',
    'CheckYourEmailConfirm': 'Sắp hoàn tất! Hãy kiểm tra email của bạn', 
    'SentEmailConfirmAcc1': 'Kiểm tra email và bấm link chúng tôi vừa gửi để hoàn tất xác nhận.',
    'SentEmailConfirmAccReg': 'Đường link xác thực đã được gửi đến email của bạn. Click chọn đường link để hoàn tất quá trình xác thực',
    'RefreshPage': 'Bạn đã đăng ký thành công. Vui lòng F5 để làm mới trang.',
    'SentEmailConfirmAcc2': 'Hãy đảm bảo bạn kiểm tra cả hòm thư rác.',
    'SentEmailConfirmAccReg2': 'Hãy nhớ kiểm tra mục Thư rác/Spam.',
    'EmailSupportEmail': 'Nếu có thắc mắc, hãy nhắn cho chúng tôi qua',
    'GlotSupportEmail': 'support@ejoy-english.com',
    'Back': 'Quay lại',
    'BackToLoginFullPage':'Quay lại trang Đăng nhập',
    'emailIsInvalid': 'Email không khả dụng',
    'Auth.form.error.invalid':'Tên đăng nhập hoặc mật khẩu không đúng',
    'openYourBrowser': 'Hãy mở trình duyệt ngoài',
    'openYourBrowserDesc': 'Để bảo mật thông tin, bạn hãy đăng nhập và thanh toán ở trình duyệt bên ngoài của bạn.',
    'gotIt': 'Hiểu rồi'
  }
}
